/**
 * sophior-cadeaugids.js
 * Hoort bij sections/sophior-cadeaugids.liquid: de budgettabs en de
 * snelknoppen. Het actieblok op datum doet sophior-lp-verkoop.js.
 */

/*
 * Budgettabs. In de HTML staan alle panelen onder elkaar, elk met een eigen
 * kop (zoekmachines en bezoekers zonder JavaScript zien alles). Hier worden
 * het tabs volgens het ARIA-patroon: pijltjes links en rechts, Home en End,
 * één tab in de tabvolgorde. Een anker als #tot-50 opent dat paneel.
 */
(function () {
  var houder = document.querySelector('[data-cg-tabs]');
  if (!houder) return;

  var lijst = houder.querySelector('[role="tablist"]');
  var tabs = Array.prototype.slice.call(houder.querySelectorAll('[role="tab"]'));
  var panelen = Array.prototype.slice.call(houder.querySelectorAll('[data-cg-paneel]'));
  if (!lijst || tabs.length < 2 || tabs.length !== panelen.length) return;

  panelen.forEach(function (paneel, i) {
    paneel.setAttribute('role', 'tabpanel');
    paneel.setAttribute('aria-labelledby', tabs[i].id);
    paneel.setAttribute('tabindex', '0');
  });
  lijst.hidden = false;

  function kies(index, focus) {
    tabs.forEach(function (tab, i) {
      var actief = i === index;
      tab.setAttribute('aria-selected', actief ? 'true' : 'false');
      tab.tabIndex = actief ? 0 : -1;
      panelen[i].hidden = !actief;
    });
    if (focus) tabs[index].focus();
  }

  tabs.forEach(function (tab, i) {
    tab.addEventListener('click', function () {
      kies(i, false);
    });
    tab.addEventListener('keydown', function (e) {
      var nieuw = null;
      if (e.key === 'ArrowRight') nieuw = (i + 1) % tabs.length;
      else if (e.key === 'ArrowLeft') nieuw = (i - 1 + tabs.length) % tabs.length;
      else if (e.key === 'Home') nieuw = 0;
      else if (e.key === 'End') nieuw = tabs.length - 1;
      if (nieuw === null) return;
      e.preventDefault();
      kies(nieuw, true);
    });
  });

  function vanAnker() {
    var id = window.location.hash.slice(1);
    if (!id) return false;
    for (var i = 0; i < panelen.length; i++) {
      if (panelen[i].id === id) {
        kies(i, false);
        lijst.scrollIntoView({ block: 'start' });
        return true;
      }
    }
    return false;
  }

  if (!vanAnker()) kies(0, false);
  window.addEventListener('hashchange', vanAnker);
})();

/*
 * Snelknoppen: de bestseller bij elke optie ([data-cg-add]) en de snelknop op
 * de productkaarten in deze sectie. Die laatste vangt de sectie zelf af
 * (stopPropagation vóór de algemene listener in sophior-collection.js), zodat
 * elke toevoeging vanaf deze pagina de verborgen regel-eigenschap
 * _sophior_source: cadeaupagina krijgt. Daarna dezelfde events als overal:
 * sophior:cart-updated en sophior:open-cart.
 */
(function () {
  var root = document.querySelector('[data-cg]');
  if (!root) return;

  var live = root.querySelector('[data-cg-live]');

  function meld(tekst) {
    if (!live) return;
    live.textContent = '';
    window.setTimeout(function () {
      live.textContent = tekst;
    }, 50);
  }

  root.addEventListener('click', function (e) {
    var knop = e.target.closest('[data-cg-add], .sophior-product-card__quick-add[data-product-id]');
    if (!knop || !root.contains(knop)) return;
    e.stopPropagation();
    if (knop.disabled) return;

    var variantId = knop.getAttribute('data-cg-add') || knop.getAttribute('data-product-id');
    if (!variantId) return;

    var origineel = knop.textContent.trim();
    var bezig = knop.getAttribute('data-adding') || root.getAttribute('data-adding') || '...';
    var klaar = knop.getAttribute('data-added') || root.getAttribute('data-added') || '✓';
    var fout = knop.getAttribute('data-error') || root.getAttribute('data-error') || 'Toevoegen mislukt, probeer het opnieuw.';

    knop.disabled = true;
    knop.textContent = bezig;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: { _sophior_source: 'cadeaupagina' }
      })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Toevoegen mislukt: ' + r.status);
        return r.json();
      })
      .then(function () {
        knop.textContent = klaar;
        meld(klaar);
        document.dispatchEvent(new CustomEvent('sophior:cart-updated'));
        document.dispatchEvent(new CustomEvent('sophior:open-cart'));
        window.setTimeout(function () {
          knop.textContent = origineel;
          knop.disabled = false;
        }, 1500);
      })
      .catch(function () {
        knop.textContent = origineel;
        knop.disabled = false;
        meld(fout);
      });
  });
})();
